export default __webpack_public_path__ + "static/media/BSG-logo.d9c1a183.svg";